import axios from "axios";
import {
  GET_PATIENTS_REQUEST,
  GET_PATIENTS_SUCCESS,
  GET_PATIENTS_FAIL,
  GET_ALL_PATIENTS_REQUEST,
  GET_ALL_PATIENTS_SUCCESS,
  GET_ALL_PATIENTS_FAIL,
  CREATE_PATIENT_REQUEST,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_FAIL,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  DELETE_PATIENT_FAIL,
  GET_PATIENT_DETAILS_REQUEST,
  GET_PATIENT_DETAILS_SUCCESS,
  GET_PATIENT_DETAILS_FAIL,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAIL,
  GET_PATIENT_ACTIVITY_LOG_REQUEST,
  GET_PATIENT_ACTIVITY_LOG_SUCCESS,
  GET_PATIENT_ACTIVITY_LOG_FAIL,
  GET_PATIENT_TREATMENT_PLANS_REQUEST,
  GET_PATIENT_TREATMENT_PLANS_SUCCESS,
  GET_PATIENT_TREATMENT_PLANS_FAIL,
  PATIENT_ADDRESS_STATES_REQUEST,
  PATIENT_ADDRESS_STATES_SUCCESS,
  PATIENT_ADDRESS_STATES_FAIL,
  PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_REQUEST,
  PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_SUCCESS,
  PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_FAIL,
  PATIENT_VERIFY_PORTAL_PIN_REQUEST,
  PATIENT_VERIFY_PORTAL_PIN_SUCCESS,
  PATIENT_VERIFY_PORTAL_PIN_FAIL,
  PATIENT_VERIFY_PORTAL_PIN_RESET,
  PATIENT_REFRESH_PORTAL_TOKEN_REQUEST,
  PATIENT_REFRESH_PORTAL_TOKEN_SUCCESS,
  PATIENT_REFRESH_PORTAL_TOKEN_FAIL,
  PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_REQUEST,
  PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_SUCCESS,
  PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_FAIL,
  PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_REQUEST,
  PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_SUCCESS,
  PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_FAIL,
  PATIENT_PORTAL_APPROVE_PLAN_REQUEST,
  PATIENT_PORTAL_APPROVE_PLAN_SUCCESS,
  PATIENT_PORTAL_APPROVE_PLAN_FAIL,
  PATIENT_PORTAL_CANCEL_PLAN_REQUEST,
  PATIENT_PORTAL_CANCEL_PLAN_SUCCESS,
  PATIENT_PORTAL_CANCEL_PLAN_FAIL,
} from "../constants/patientConstants";

// export const getPatientsList =
//   (
//     searchTerm = "",
//     page = 1,
//     pageSize = 10,
//     sortField = "",
//     sortOrder = "",
//     minAge = "",
//     maxAge = "",
//     state = "",
//     status = "",
//     startDate = "",
//     endDate = ""
//   ) =>
//   async (dispatch, getState) => {
//     try {
//       dispatch({
//         type: GET_PATIENTS_REQUEST,
//       });

//       const {
//         authLogin: { userInfo },
//       } = getState();

//       const config = {
//         headers: {
//           Authorization: `Bearer ${userInfo.token}`,
//         },
//       };

//       // console.log("userInfo in action, ", userInfo);

//       // Constructing the query string
//       let query = `/api/patients?`;
//       query += `searchTerm=${encodeURIComponent(searchTerm)}`;
//       query += `&pageNumber=${page}`;
//       query += `&pageSize=${pageSize}`;
//       if (sortField) query += `&sortField=${sortField}`;
//       if (sortOrder) query += `&sortOrder=${sortOrder}`;
//       if (minAge) query += `&minAge=${encodeURIComponent(minAge)}`;
//       if (maxAge) query += `&maxAge=${encodeURIComponent(maxAge)}`;
//       if (state) query += `&state=${encodeURIComponent(state)}`;
//       if (status) query += `&status=${encodeURIComponent(status)}`;
//       if (startDate) query += `&startDate=${encodeURIComponent(startDate)}`;
//       if (endDate) query += `&endDate=${encodeURIComponent(endDate)}`;

//       const { data } = await axios.get(query, config);

//       // console.log("DATA ACTION", data);

//       dispatch({
//         type: GET_PATIENTS_SUCCESS,
//         payload: data,
//       });
//     } catch (error) {
//       dispatch({
//         type: GET_PATIENTS_FAIL,
//         payload:
//           error.response && error.response.data.message
//             ? error.response.data.message
//             : error.message,
//       });
//     }
//   };

export const getPatientsList =
  (
    searchTerm = "",
    page = 1,
    pageSize = 10,
    sortField = "",
    sortOrder = "",
    minAge = "",
    maxAge = "",
    state = "",
    status = "",
    startDate = "",
    endDate = "",
    slug
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_PATIENTS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // console.log("userInfo in action, ", userInfo);
      console.log("slug in action, ", slug);

      // Constructing the query string
      let query = `/api/${slug}/patients?`;
      query += `searchTerm=${encodeURIComponent(searchTerm)}`;
      query += `&pageNumber=${page}`;
      query += `&pageSize=${pageSize}`;
      if (sortField) query += `&sortField=${sortField}`;
      if (sortOrder) query += `&sortOrder=${sortOrder}`;
      if (minAge) query += `&minAge=${encodeURIComponent(minAge)}`;
      if (maxAge) query += `&maxAge=${encodeURIComponent(maxAge)}`;
      if (state) query += `&state=${encodeURIComponent(state)}`;
      if (status) query += `&status=${encodeURIComponent(status)}`;
      if (startDate) query += `&startDate=${encodeURIComponent(startDate)}`;
      if (endDate) query += `&endDate=${encodeURIComponent(endDate)}`;

      const { data } = await axios.get(query, config);

      // console.log("DATA ACTION", data);

      dispatch({
        type: GET_PATIENTS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_PATIENTS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const createPatient =
  (
    firstName,
    lastName,
    birthDate,
    personalCode,
    gender,
    phone,
    phoneAlt,
    email,
    street,
    zip,
    city,
    country,
    state,
    child,
    status,
    defaultNewStatusExpiration,
    representativeFirstName,
    representativeLastName,
    representativePhone,
    representativeEmail,
    representativeType,
    slug
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_PATIENT_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `/api/${slug}/patients/create`,
        {
          firstName,
          lastName,
          birthDate,
          personalCode,
          gender,
          phone,
          phoneAlt,
          email,
          street,
          zip,
          city,
          country,
          state,
          child,
          status,
          defaultNewStatusExpiration,
          representativeFirstName,
          representativeLastName,
          representativePhone,
          representativeEmail,
          representativeType,
          slug,
        },
        config
      );

      dispatch({
        type: CREATE_PATIENT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_PATIENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getAllPatientsList =
  (searchTerm = "", slug) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_ALL_PATIENTS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // Construct the URL with the search term if it's provided
      const query = searchTerm
        ? `?searchTerm=${encodeURIComponent(searchTerm)}`
        : "";
      const { data } = await axios.get(
        `/api/${slug}/patients/all${query}`,
        config
      );

      dispatch({
        type: GET_ALL_PATIENTS_SUCCESS,
        payload: data, // Ensure that data contains the list of all patients
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_PATIENTS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deletePatientAction = (id, slug) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_PATIENT_REQUEST });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`/api/${slug}/patients/${id}`, config);

    dispatch({ type: DELETE_PATIENT_SUCCESS });

    // Optionally, you can dispatch another action to refresh the patient list
    // dispatch(getPatientsList());
  } catch (error) {
    dispatch({
      type: DELETE_PATIENT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const getPatientDetailsAction =
  (id, slug) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_PATIENT_DETAILS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(`/api/${slug}/patients/${id}`, config);

      dispatch({
        type: GET_PATIENT_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: GET_PATIENT_DETAILS_FAIL,
        payload: message,
      });
    }
  };

export const updatePatientAction =
  (patient, slug) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_PATIENT_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/patients/${patient._id}`,
        patient,
        config
      );

      dispatch({ type: UPDATE_PATIENT_SUCCESS, payload: data });

      dispatch(getPatientDetailsAction(patient._id, slug));
      dispatch(getPatientTreatmentPlansAction(slug, patient._id));
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: UPDATE_PATIENT_FAIL,
        payload: message,
      });
    }
  };

export const getPatientActivityLogAction =
  (slug, patientId, page = 1, pageSize = 20, all = false) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PATIENT_ACTIVITY_LOG_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      let query = `/api/${slug}/patients/${patientId}/activity?page=${page}&pageSize=${pageSize}`;

      // If 'all' is true, modify the query to load all logs
      if (all) {
        query += `&all=true`;
      }

      const { data } = await axios.get(query, config);

      dispatch({
        type: GET_PATIENT_ACTIVITY_LOG_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_PATIENT_ACTIVITY_LOG_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
export const getPatientTreatmentPlansAction =
  (
    slug,
    patientId,
    pageNumber = "", // Default page number
    pageSize = "", // Default page size
    sortField = "", // Default sort field
    sortOrder = "", // Default sort order
    searchTerm = "", // Search term
    all = false // Option to fetch all records
    // status = "", // Filter by status
    // minPrice = "", // Minimum price filter
    // maxPrice = "", // Maximum price filter
    // startDate = "", // Start date filter
    // endDate = "" // End date filter
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PATIENT_TREATMENT_PLANS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // Constructing the query string dynamically
      let query = `/api/${slug}/patients/${patientId}/treatment-plans?`;

      if (sortField) query += `sortField=${encodeURIComponent(sortField)}&`;
      if (sortOrder) query += `sortOrder=${encodeURIComponent(sortOrder)}&`;
      if (searchTerm) query += `searchTerm=${encodeURIComponent(searchTerm)}&`;

      if (all) {
        query += `all=true&`; // Fetch all treatment plans without pagination
      } else {
        query += `page=${pageNumber}&pageSize=${pageSize}&`;
      }

      // Add filters if they are provided
      // if (status) query += `status=${encodeURIComponent(status)}&`;
      // if (minPrice) query += `minPrice=${encodeURIComponent(minPrice)}&`;
      // if (maxPrice) query += `maxPrice=${encodeURIComponent(maxPrice)}&`;
      // if (startDate) query += `startDate=${encodeURIComponent(startDate)}&`;
      // if (endDate) query += `endDate=${encodeURIComponent(endDate)}&`;

      // Remove trailing `&` if present
      query = query.replace(/&$/, "");

      // console.log("Constructed Query:", query); // Debugging

      // Make the request to the backend
      const { data } = await axios.get(query, config);

      dispatch({
        type: GET_PATIENT_TREATMENT_PLANS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: GET_PATIENT_TREATMENT_PLANS_FAIL,
        payload: message,
      });
    }
  };

export const getAllPatientAddressStates =
  (slug) => async (dispatch, getState) => {
    try {
      dispatch({ type: PATIENT_ADDRESS_STATES_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          // 'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `/api/${slug}/patients/address-states`,
        config
      );

      dispatch({
        type: PATIENT_ADDRESS_STATES_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PATIENT_ADDRESS_STATES_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getPatientPortalPublicDetailsAction =
  (slug, patientId) => async (dispatch) => {
    try {
      dispatch({ type: PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_REQUEST });

      const { data } = await axios.get(
        `/api/${slug}/patients/portal/${patientId}`
      );

      dispatch({
        type: PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const verifyPatientPortalPinAction =
  (tenantID, patientId, pinCode) => async (dispatch) => {
    try {
      dispatch({ type: PATIENT_VERIFY_PORTAL_PIN_REQUEST });

      const { data } = await axios.post(
        `/api/patients/portal/${tenantID}/${patientId}/verify-pin`,
        { pinCode }
      );

      dispatch({
        type: PATIENT_VERIFY_PORTAL_PIN_SUCCESS,
        payload: data, // Contains token and patient info
      });

      // ✅ Store patient data in localStorage under "patientInfo"
      localStorage.setItem("patientInfo", JSON.stringify(data));

      return data;
    } catch (error) {
      dispatch({
        type: PATIENT_VERIFY_PORTAL_PIN_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const logoutPatientPortalAction = () => (dispatch) => {
  localStorage.removeItem("patientInfo");
  dispatch({ type: PATIENT_VERIFY_PORTAL_PIN_RESET });
};

export const refreshPatientPortalTokenAction =
  (tenantID, patientId) => async (dispatch) => {
    try {
      dispatch({ type: PATIENT_REFRESH_PORTAL_TOKEN_REQUEST });

      const { data } = await axios.post(
        `/api/patients/portal/${tenantID}/${patientId}/refresh-token`
      );

      dispatch({
        type: PATIENT_REFRESH_PORTAL_TOKEN_SUCCESS,
        payload: data,
      });

      // ✅ Store patient data in localStorage under "patientInfo"
      localStorage.setItem("patientInfo", JSON.stringify(data));

      return data;
    } catch (error) {
      dispatch({
        type: PATIENT_REFRESH_PORTAL_TOKEN_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const getPatientPortalTreatmentPlansAction =
  (tenantID, patientId, token) => async (dispatch) => {
    try {
      dispatch({ type: PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_REQUEST });

      if (!token) {
        throw new Error("No token provided");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ use the prop
        },
      };

      const { data } = await axios.get(
        `/api/patients/portal/${tenantID}/${patientId}/treatment-plans`,
        config
      );

      dispatch({
        type: PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const downloadPatientTreatmentPlanPdfAction =
  (tenantID, patientId, treatmentPlanId, token) => async (dispatch) => {
    try {
      dispatch({ type: PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_REQUEST });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // 👈 Important to handle binary PDF response
      };

      const { data } = await axios.get(
        `/api/patients/portal/${tenantID}/${patientId}/treatment-plans/${treatmentPlanId}/download`,
        config
      );

      dispatch({ type: PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_SUCCESS });

      // You can optionally return the blob for file saving (e.g., with file-saver)
      return data;
    } catch (error) {
      dispatch({
        type: PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const approvePatientTreatmentPlanFromPortalAction =
  (tenantID, patientId, treatmentPlanId, token) => async (dispatch) => {
    try {
      dispatch({ type: PATIENT_PORTAL_APPROVE_PLAN_REQUEST });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `/api/patients/portal/${tenantID}/${patientId}/treatment-plans/${treatmentPlanId}/approve`,
        {},
        config
      );

      dispatch({
        type: PATIENT_PORTAL_APPROVE_PLAN_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: PATIENT_PORTAL_APPROVE_PLAN_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const cancelPatientTreatmentPlanFromPortalAction =
  (
    tenantID,
    patientId,
    treatmentPlanId,
    cancelledReason,
    cancelledComment,
    token
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: PATIENT_PORTAL_CANCEL_PLAN_REQUEST });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // console.log("body action", {
      //   tenantID,
      //   patientId,
      //   treatmentPlanId,
      //   cancelledReason,
      //   cancelledComment,
      //   token,
      // });

      const { data } = await axios.put(
        `/api/patients/portal/${tenantID}/${patientId}/treatment-plans/${treatmentPlanId}/cancel`,
        {
          cancelledReason,
          cancelledComment,
        },
        config
      );

      dispatch({
        type: PATIENT_PORTAL_CANCEL_PLAN_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: PATIENT_PORTAL_CANCEL_PLAN_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
